import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

function NavButton({ t, type }) {
  const history = useHistory()
  const location = useSelector((state) => state.router.location.pathname)
  const totalNewAssignments =
    useSelector((state) => state.assignment.totalNewAssignments) ?? 0
  const totalNewApplications =
    useSelector((state) => state.assignment.totalNewApplications) ?? 0
  const totalNewWorkShifts =
    useSelector((state) => state.workShiftUser.totalNewWorkshifts) ?? 0

  const buttonConfig = {
    openforwork: [
      { label: 'sel1', path: '/dashboard/openforwork/assignments' },
      { label: 'sel2', path: '/dashboard/openforwork/applications' },
      { label: 'sel3', path: '/dashboard/openforwork/workShifts' }
    ],
    profile: [
      { label: 'sel1', path: '/dashboard/profile' },
      { label: 'sel2', path: '/dashboard/profile/openforwork' }
    ]
  }

  const translationKeyMap = {
    openforwork: 'openForWork',
    profile: 'profile'
  }

  const buttons = buttonConfig[type] || []
  const translationKey = translationKeyMap[type] || type

  // Styles for desktop and mobile
  const styles = {
    container: {
      paddingBottom: '20px',
      display: 'flex',
      justifyContent: 'center'
    },
    list: {
      display: 'flex',
      flexDirection: 'row', // Default to horizontal layout
      listStyleType: 'none',
      padding: 0,
      margin: 0
    },
    listItem: {
      display: 'inline',
      padding: '10px',
      cursor: 'pointer',
      borderRadius: '8px',
      textAlign: 'center',
      position: 'relative'
    },
    activeListItem: {
      backgroundColor: '#44c0cc',
      color: '#FFFFFF'
    },
    // Mobile-specific styles
    '@media (max-width: 600px)': {
      list: {
        flexDirection: 'column', // Stack items vertically on smaller screens
        alignItems: 'center'
      },
      listItem: {
        width: '100%', // Make items full-width for easier tapping
        marginBottom: '10px'
      }
    },
    notificationDot: {
      position: 'absolute',
      top: '2px',
      left: '2px',
      width: '10px',
      height: '10px',
      backgroundColor: '#F67131',
      borderRadius: '50%'
    }
  }

  return (
    <div style={styles.container}>
      <ul style={styles.list}>
        {buttons.map(({ label, path }) => (
          <li
            key={label}
            onClick={() => history.push(path)}
            style={{
              ...styles.listItem,
              ...(location === path ? styles.activeListItem : {})
            }}
          >
            <b>{t(`${translationKey}.${label}`)}</b>
            {totalNewAssignments > 0 &&
              label === 'sel1' &&
              location.includes('dashboard/openforwork') && (
                <span style={styles.notificationDot}></span>
              )}
            {totalNewApplications > 0 &&
              label === 'sel2' &&
              location.includes('dashboard/openforwork') && (
                <span style={styles.notificationDot}></span>
              )}
            {totalNewWorkShifts > 0 &&
              label === 'sel3' &&
              location.includes('dashboard/openforwork') && (
                <span style={styles.notificationDot}></span>
              )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default NavButton
